import React from 'react';
import { NavLink } from 'react-router-dom';
import { Mail, Phone, MapPin, ExternalLink, ArrowRight } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative mt-16 md:mt-24 border-t border-gray-200 dark:border-gray-800 bg-white/50 dark:bg-dark-bg/50 backdrop-blur-xl">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-8 md:py-12">
        <div className="xl:grid xl:grid-cols-3 xl:gap-8">
          
          {/* Brand & Info */}
          <div className="space-y-6 md:space-y-8 xl:col-span-1">
            <NavLink to="/" className="flex items-center gap-2">
              <div className="w-8 h-8 rounded-full bg-gradient-to-tr from-primary-600 to-primary-400 flex items-center justify-center text-white font-bold text-lg">
                R
              </div>
              <span className="text-xl font-bold tracking-tight">
                Randev<span className="text-primary-600 dark:text-primary-400">UPP</span>
              </span>
            </NavLink>
            <p className="text-sm leading-6 text-gray-600 dark:text-gray-400 max-w-sm">
              Kendi markanızın altında işletmenizi yönetin. Kuaförler, güzellik salonları ve nail art stüdyoları için yeni nesil işletme yönetim sistemi.
            </p>
            <div className="p-3 md:p-4 rounded-2xl bg-gray-50 dark:bg-gray-900 border border-gray-100 dark:border-gray-800 inline-block w-full sm:w-auto">
              <p className="text-sm font-medium text-gray-900 dark:text-white flex items-center gap-2">
                Bir <a href="https://www.vireliosoft.com" target="_blank" rel="noreferrer" className="text-primary-600 hover:underline inline-flex items-center gap-1">Vireliosoft <ExternalLink size={14}/></a> ürünüdür.
              </p>
            </div>
          </div>

          {/* Links Grid */}
          <div className="mt-10 md:mt-16 grid grid-cols-1 sm:grid-cols-2 gap-8 xl:col-span-2 xl:mt-0">
            <div className="grid grid-cols-2 gap-8">
              <div>
                <h3 className="text-sm font-semibold leading-6 text-gray-900 dark:text-white">Menü</h3>
                <ul className="mt-4 md:mt-6 space-y-3 md:space-y-4">
                  <li>
                    <NavLink to="/" className="text-sm leading-6 text-gray-600 dark:text-gray-400 hover:text-primary-600 dark:hover:text-primary-400 transition-colors">Ana Sayfa</NavLink>
                  </li>
                  <li>
                    <NavLink to="/features" className="text-sm leading-6 text-gray-600 dark:text-gray-400 hover:text-primary-600 dark:hover:text-primary-400 transition-colors">Özellikler</NavLink>
                  </li>
                  <li>
                    <NavLink to="/pricing" className="text-sm leading-6 text-gray-600 dark:text-gray-400 hover:text-primary-600 dark:hover:text-primary-400 transition-colors">Fiyatlandırma</NavLink>
                  </li>
                </ul>
              </div>
              <div>
                <h3 className="text-sm font-semibold leading-6 text-gray-900 dark:text-white">İletişim</h3>
                <ul className="mt-4 md:mt-6 space-y-3 md:space-y-4">
                  <li>
                    <a href="mailto:contact@vireliosoft.com" className="flex items-center gap-2 text-sm leading-6 text-gray-600 dark:text-gray-400 hover:text-primary-600 dark:hover:text-primary-400 transition-colors">
                      <Mail size={16} className="shrink-0" /> <span className="truncate">contact@vireliosoft.com</span>
                    </a>
                  </li>
                  <li>
                    <a href="tel:+908508403917" className="flex items-center gap-2 text-sm leading-6 text-gray-600 dark:text-gray-400 hover:text-primary-600 dark:hover:text-primary-400 transition-colors">
                      <Phone size={16} className="shrink-0" /> <span>+90 850 840 3917</span>
                    </a>
                  </li>
                  <li className="flex items-start gap-2 text-sm leading-6 text-gray-600 dark:text-gray-400">
                    <MapPin size={16} className="mt-1 shrink-0" />
                    <span>Yunusemre Mah. 6428. Sok. No 4 Pamukkale/Denizli</span>
                  </li>
                </ul>
              </div>
            </div>
            
            <div className="mt-4 sm:mt-0">
              <h3 className="text-sm font-semibold leading-6 text-gray-900 dark:text-white">Referanslarımız</h3>
              <p className="mt-4 md:mt-6 text-sm text-gray-600 dark:text-gray-400 mb-4 max-w-xs">
                Sistemimizi kullanan mutlu işletmelere göz atın.
              </p>
              <a 
                href="https://vireliosoft.com/references"
                target="_blank" 
                rel="noreferrer"
                className="inline-flex items-center gap-2 text-sm font-medium text-primary-600 dark:text-primary-400 hover:text-primary-700 dark:hover:text-primary-300 group bg-primary-50 dark:bg-primary-900/20 px-4 py-2 rounded-lg transition-colors"
              >
                Referansları İncele
                <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
              </a>
            </div>
          </div>
        </div>
        
        {/* Bottom Bar */}
        <div className="mt-10 md:mt-16 border-t border-gray-200 dark:border-gray-800 pt-6 md:pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs leading-5 text-gray-500 text-center md:text-left">
            &copy; {currentYear} Vireliosoft Yazılım Çözümleri. Tüm hakları saklıdır.
          </p>
          <div className="flex flex-col sm:flex-row items-center gap-6">
            <div className="flex items-center">
              <img 
                src="/footer_iyzico_ile_ode/Colored/logo_band_colored.svg" 
                alt="iyzico güvenli ödeme" 
                className="h-6 md:h-8 dark:hidden" 
              />
              <img 
                src="/footer_iyzico_ile_ode/White/logo_band_white.svg" 
                alt="iyzico güvenli ödeme" 
                className="h-6 md:h-8 hidden dark:block" 
              />
            </div>
            <a href="https://instagram.com/randevupp" target="_blank" rel="noreferrer" className="text-gray-400 hover:text-gray-500 dark:hover:text-gray-300 text-sm transition-colors">
              Instagram: @randevupp
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
